<div class="wrap">

    <div class="uk-margin uk-display-inline-block research-form-controls">
        <div class="uk-form-controls uk-display-inline-block">
            <button class="uk-button round-button uk-display-inline-block" [class.round-button-toggle]="status === -1" (click)="changeStatus(-1)">
                Tout
            </button>
        </div>
        <div class="uk-form-controls uk-display-inline-block uk-margin-small-left">
            <button class="uk-button round-button uk-display-inline-block" [class.round-button-toggle]="status === 0" (click)="changeStatus(0)">
                Nouveau
            </button>
        </div>
        <div class="uk-form-controls uk-display-inline-block uk-margin-small-left">
            <button class="uk-button round-button uk-display-inline-block" [class.round-button-toggle]="status === 1" (click)="changeStatus(1)">
                À traiter
            </button>
        </div>
        <div class="uk-form-controls uk-display-inline-block uk-margin-small-left">
            <button class="uk-button round-button uk-display-inline-block" [class.round-button-toggle]="status === 2" (click)="changeStatus(2)">
                Archivée
            </button>
        </div>
    </div>

    <div class="uk-margin-medium-left uk-display-inline-block research-form-controls">
        <div class="uk-form-controls uk-display-inline-block">
            <app-datepicker [(date)]="dateStart" (dateChange)="onDateChange(true, $event)"></app-datepicker>
            <app-datepicker [(date)]="dateEnd" (dateChange)="onDateChange(false, $event)"></app-datepicker>
        </div>
    </div>

    <div *ngIf="noResult === true" class="bold uk-margin-medium-top">
        Aucune alerte à afficher pour cette période.
    </div>

    <div *ngIf="loadingStatus === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loadingStatus === false && noResult === false" class="container">
        <div uk-grid *ngFor="let state of stateOfCarService.stateOfCars; let i = index"
        class="uk-width-1-1 item-list light color-grey remove-grid-ml-pl" style="height: 124px;">
            <div class="uk-width-2-12 item-column img-wrap" style="background: #eaeaea;">
                <div uk-lightbox>
                    <a class="uk-button uk-button-default" [href]="state.imgs[0]">
                        <img class="uk-position-absolute"
                        [src]="state.imgs[0]" alt="adherent"
                        onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';"/>
                    </a>
                </div>
            </div>
            <div class="uk-width-10-12 item-column remove-grid-ml-pl" uk-grid
            style="padding-left: 20px !important; padding-right: 20px !important;">
                <div class="uk-width-4-12 item-column bold border" style="font-size: 15px;">
                    <span class="title">État des lieux</span>
                </div>
                <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;">
                    <span humanDateFormat="{{ state.ISOCreated }}" noDay="true" shortened="true"></span>
                </div>
                <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;">
                    <span hours="{{ state.ISOCreated }}"></span>
                </div>
                <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;">
                    <div>
                        <span class="material-icons vertical-align-middle" [class.color-green]="state.state === 0"
                        [class.color-orange]="state.state === 1">fiber_manual_record</span>
                        <span *ngIf="state.state === 0" class="title bold vertical-align-middle uk-margin-small-left">Nouveau</span>
                        <span *ngIf="state.state === 1" class="title bold vertical-align-middle uk-margin-small-left">À traîter</span>
                        <span *ngIf="state.state === 2" class="title bold vertical-align-middle uk-margin-small-left">Archivé</span>
                    </div>
                </div>
                <div class="uk-width-2-12 item-column border">
                    <button class="back-button uk-text-right" href="#state-of-car-informations" uk-toggle (click)="bindSinister(state)">
                        <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="edit"/>
                    </button>
                    <button class="back-button uk-text-right" [routerLink]="['/ressource/vehicle/informations', state.idVehicle]">
                        <img src="../../../assets/icons/Vehicle.svg" width="32px" height="32px" alt="edit"/>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="uk-margin-large"></div>
</div>

<app-state-of-car-informations
    [id]="boundSinister.id"
    [status]="boundSinister.status"
    (changed)="onSinisterStatusChanged($event)"
></app-state-of-car-informations>